import React, { useState, useEffect } from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/16/solid'
import { searchPlaces } from '../../../../../modules/google-maps'

const PlacesSearch = ({ initSearch, location, updateField }) => {
  const [query, setQuery] = useState('')
  const [radius, setRadius] = useState(10);

  useEffect(() => {
    if(!initSearch) return;

    setQuery(initSearch)
  }, [initSearch])

  function handleSubmit(e) {
    e.preventDefault();
    searchPlaces(query, radius, location)
      .then((data) => {
        console.log(data);
        updateField('places_response', {
          places: data,
          place: location.places_response?.place
        })
      })
  }

  return (
    <div className="mt-3 flex">
      {/*<select*/}
      {/*  value={radius}*/}
      {/*  className='appearance-none bg-none text-xs mr-2 rounded-md bg-white px-2 py-1.5  outline outline-1 -outline-offset-1 outline-gray-300 text-sm font-semibold text-gray-900 hover:bg-gray-50'*/}
      {/*  onChange={(e) => {*/}
      {/*    setRadius(parseInt(e.target.value));*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <option value={0}>R0</option>*/}
      {/*  <option value={10}>R10</option>*/}
      {/*  <option value={100}>R100</option>*/}
      {/*  <option value={1000}>R1000</option>*/}
      {/*  <option value={10000}>R10000</option>*/}
      {/*</select>*/}
      <div className="-mr-px grid grow grid-cols-1 focus-within:relative">
        <input
          id="query"
          name="query"
          type="text"
          value={query}
          onChange={(e) => {
            e.preventDefault();
            setQuery(e.target.value)
          }}
          placeholder="123 Main Street"
          className="col-start-1 row-start-1 block w-full rounded-l-md bg-white py-1.5 pl-3 pr-3 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-indigo-600 sm:pl-3 sm:text-sm/6"
        />
      </div>
      <button
        type="button"
        onClick={handleSubmit}
        className="flex shrink-0 items-center gap-x-1.5 rounded-r-md bg-white pr-3 py-2 text-sm font-semibold text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 hover:bg-gray-50 focus:relative focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
      >
        <MagnifyingGlassIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4"
        />
      </button>
    </div>
  );
};

export default PlacesSearch;